import type { PropsWithChildren } from 'react';

import { TagVariants } from './Tag.enums';

export enum TAG_CONST {
  TEST_ID = 'tag',
}

type Tag = {
  variant?: `${TagVariants}`;
};

export type TagProps = PropsWithChildren<Tag>;
